module.exports = __webpack_public_path__ + "static/media/car-banner.1cac5993.png";